import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { CardTemplate } from '../../templates/CardTemplate';
import { ResetPasswordForm } from '../../organisms/form/ResetPasswordForm';
import { useResetPasswordPage } from './hook';

export const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const { handleResetPassword } = useResetPasswordPage();
  const uid = searchParams.get('uid');
  const token = searchParams.get('token');

  const handleSubmit = (password: string, onError: (msg: string) => void) => {
    if (!uid || !token) {
      onError('Invalid or expired reset link.');
      return;
    }
    handleResetPassword(password, uid, token, onError);
  };

  return (
    <CardTemplate title={"Reset Password"}>
      <ResetPasswordForm handleSubmit={handleSubmit} />
    </CardTemplate>
  );
};
